import { put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../../configs';
import { OK } from '../../../../configs/serverStatusCodes';
import makeRequest from '../../../../utils/makeRequest';
import { setBlackWhitesModuleStatus } from '../../actions';
import { isBlackWhitesModuleUnavailableStatus } from './moduleStatus';

export default function* checkBlackWhitesModuleStatus() {
  try {
    const url = `${BACKEND_URL}/proxy/black-white/v1/blackwhites/`;
    const dataResponse = yield makeRequest(url, { page: 1, limit: 1, type: 'BLACK' }, null, 'GET', true);

    if (dataResponse.status === OK) {
      yield put(setBlackWhitesModuleStatus({ available: true, checked: true }));
      return;
    }

    if (isBlackWhitesModuleUnavailableStatus(dataResponse.status)) {
      yield put(setBlackWhitesModuleStatus({ available: false, checked: true }));
      return;
    }

    yield put(setBlackWhitesModuleStatus({ available: true, checked: true }));
  } catch (e) {
    yield put(setBlackWhitesModuleStatus({ available: false, checked: true }));
  }
}
